import axios from "axios";

const apiurl = "http://api.sajidmohammed.com/api/contact";

var create = (data) => {
    return axios({
        method: 'post',
        url: apiurl,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        data: {
            first_name: data.first_name,
            last_name: data.last_name,
            mobile: data.mobile,
            email: data.email,
            message: data.message
        }
    });
}

export {create};


// WEBPACK FOOTER //
// src/api/Api.js